/**
 * Style constants for the User Memory feature. This repo has no `.styles.ts`
 * precedent — CVA is introduced here deliberately, kept small: only variants
 * that are actually reused across MemoryPage's suggested/active lists.
 */

import { cva } from 'class-variance-authority';

/** Chip shown next to each memory entry's category (style/structure/phrasing/terminology). */
export const memoryCategoryChipVariants = cva(
  'inline-flex items-center rounded-full border px-2 py-0.5 font-medium text-xs',
  {
    variants: {
      category: {
        style: 'border-blue-200 bg-blue-50 text-blue-700',
        structure: 'border-purple-200 bg-purple-50 text-purple-700',
        phrasing: 'border-teal-200 bg-teal-50 text-teal-700',
        terminology: 'border-amber-200 bg-amber-50 text-amber-700',
      },
    },
    defaultVariants: {
      category: 'style',
    },
  }
);

/** Left accent border on a memory entry card, keyed by status. */
export const memoryStatusAccentVariants = cva('rounded-lg border border-l-4 bg-white p-4', {
  variants: {
    status: {
      candidate: 'border-l-slate-300',
      suggested: 'border-l-primary',
      active: 'border-l-green-500',
      rejected: 'border-l-slate-300',
      retired: 'border-l-slate-300',
    },
  },
  defaultVariants: {
    status: 'suggested',
  },
});
